import { getErrorCode, getTranslatedErrorMessage } from '@/helpers/apiErrors';
import { invalid_sms_code, sms_code_expired } from '../locale.json';
import generateSignUpApiData from './generateSignUpApiData';

export default async function () {
  const p = this.$store.dispatch('auth/confirmRegistration', {
    // We've already sent the info like password to '/auth/register', but we need to do this again here because
    // otherwise this could happen:
    // 1. Someone else sends a request with our phone and his password to '/auth/register'.
    // 2. We try to register, get 'auth.already_registered'.
    // 3. We, having no other way to sign up, send a request to '/auth/register/resend'.
    // 4. We get an SMS code and send it to '/auth/register/confirm', with only the phone number added (no password).
    // 5. ???
    // 6. That dude from the first step has the password from our account, and we don't.
    ...generateSignUpApiData.call(this),
    code: this.code,
  });

  try {
    await p;
  } catch (err) {
    const errorMessage = getTranslatedErrorMessage(err)

    if (errorMessage !== null) {
      this.error = errorMessage

      return
    }

    const errorCode = getErrorCode(err);

    if (errorCode === 'auth.registration.invalid_confirmation_code') {
      this.error = invalid_sms_code;
      return;
    }

    // Not handling 'invalid password' because we've already sent it in the previous request to '/auth/register'.
    throw err;
  }

  this.page = 'done:signUp';
};
